<template>
</template>
<script>
	export default {
		mounted() {
			//console.log("user=LogOut");
			var _this = this;
			sessionStorage.removeItem('user');
			_this.$router.push('/login');
		}
	}
</script>


// WEBPACK FOOTER //
// LoginOut.vue?da8e0d1e